module.exports = __webpack_public_path__ + "static/media/rainier_reflection.b7d28ea7.jpg";